import { Select, NoData } from '@components';
import React, { forwardRef, useEffect, useState } from 'react';
import { Input } from 'antd';

const CompSelect = (
  { value: defaultValue, onChange, afterSelect, compData = [] },
  ref,
) => {
  const [input, setInput] = useState(null);
  const [value, setValue] = useState(defaultValue);

  const onSelect = (e) => {
    onChange(e);
    afterSelect();
    setValue(e);
  };

  const options = compData.map((comp) => ({
    name: comp.companyName,
    value: comp.companyName,
  }));

  const onInputSave = (e) => {
    e.stopPropagation();
    const newValue = e.target.value;
    onSelect(newValue);
  };

  useEffect(() => {
    if (value && !input && !options.map((o) => o.name).includes(value)) {
      setInput(value);
    }
  }, []);

  const dropdownRender = (menu) => (
    <div>
      {menu}
      <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
        <Input
          style={{ flex: 'auto' }}
          placeholder="Manual Entry"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          // onBlur={onInputSave}
          onPressEnter={onInputSave}
        />
      </div>
    </div>
  );

  return (
    <Select
      options={options}
      notFoundContent={<NoData />}
      value={value}
      onSelect={onSelect}
      dropdownRender={dropdownRender}
      dropdownClassName="comp-select-down"
    />
  );
};

export default forwardRef(CompSelect);
